import React from 'react';

const Home = () => {
  return <div>Home 1</div>
}

export default Home;
